import React, { useEffect, useState } from 'react'
import { cloneDeep } from 'lodash'
import { Tabs, Tab } from 'components/shared/Tabs'
import TableComponent from 'components/shared/TableComponent'
import { Attachments } from '../partial/Tabs/Attachments'
import { Status } from 'constants/chartData'
import { BuisnessColumns, OwnersColumn } from 'constants/application'

const detailTabs = [
    { label: 'Application' },
    { label: 'Attachments' }
]

// Read-only copies of the application tables, without the edit column
const withoutActions = (columns, hidden = []) => cloneDeep(columns)
    .filter(column => column.dataField !== 'action' && !hidden.includes(column.dataField))
// The API doesn't send owners' date of birth or SSN to sales reps
const OWNER_HIDDEN_COLUMNS = ['dateOfBirth', 'identifications[0].identification']

/**
 * What a sales rep sees of an application shared with them: the application itself and its attachments.
 * Only calls the endpoints the backend allows sales reps (the application, its files and file downloads).
 */
const SalesRepApplicationDetail = (props) => {
    const {
        applicantUUID,
        applicationData = {},
        getApplicantsById,
        dispatchProcessing,
        getFiles,
        downLoadAttachment,
        downloadFileByPayload,
        getAttachmentPDF,
        attachmentList,
        totalPages,
        totalRecords
    } = props
    const { status, business, indexName, owners = [], debtor, salesRepresentative } = applicationData
    const [detailTab, setDetailTab] = useState(0)
    const statusStyle = Status.find(st => st.status === status)
    // Debtor only when the application has one (the API sends an empty object otherwise)
    const hasDebtor = !!(debtor && (debtor.name || debtor.uuid))

    useEffect(() => {
        if (!applicantUUID) return
        dispatchProcessing(true)
        getApplicantsById(applicantUUID).finally(() => dispatchProcessing(false))
    }, [applicantUUID, getApplicantsById, dispatchProcessing])

    const renderTable = (columns, data, keyField, hidden) => (
        <TableComponent
            columns={withoutActions(columns, hidden)}
            data={data}
            keyField={keyField}
            showPagination={false}
            className='mt-3 customTable'
        />
    )

    return (
        <div id='applicantDetail'>
            <div className='applicantHeader'>
                <div className='applicantTitle'>
                    <h2 id='applicant_name'>{business?.name}</h2>
                    {status &&
                        <span className='applicationStatus' style={{
                            background: statusStyle?.code,
                            color: statusStyle?.color
                        }}>{status}</span>
                    }
                </div>
            </div>
            <div className='tabPanel mt-3'>
                <Tabs data={detailTabs} value={detailTab} onChange={(event, value) => setDetailTab(value)} />
                <Tab value={detailTab} index={0}>
                    {/* All on one page: there is room, and reps check everything at a glance */}
                    <div className='ownerTabpanel'>
                        <h5 className='mt-3 mb-0'>Business Information</h5>
                        {renderTable(BuisnessColumns, business ? [{ ...business, salesRepresentative }] : [], 'name')}
                        <h5 className='mt-4 mb-0'>Owners</h5>
                        {renderTable(OwnersColumn, owners, 'uuid', OWNER_HIDDEN_COLUMNS)}
                        {hasDebtor &&
                            <>
                                <h5 className='mt-4 mb-0'>Debtor</h5>
                                {renderTable(BuisnessColumns, [debtor], 'name')}
                            </>
                        }
                    </div>
                </Tab>
                <Tab value={detailTab} index={1}>
                    <Attachments
                        getFiles={getFiles}
                        downloadFile={downLoadAttachment}
                        downloadFileByPayload={downloadFileByPayload}
                        businessName={indexName || business?.name || ''}
                        getAttachmentPDF={getAttachmentPDF}
                        attachmentList={attachmentList}
                        totalPages={totalPages}
                        totalRecords={totalRecords}
                        applicationId={applicantUUID}
                    />
                </Tab>
            </div>
        </div>
    )
}

export default SalesRepApplicationDetail
